import { Button, Modal } from "react-bootstrap";

const ConfirmModal = ({show, handleClose, message, onConfirm}) => {

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="md"
            centered
            style={{direction:'rtl', textAlign:'right'}}
            className="modalOnModal"
            backdropClassName=" backOnModal"
        >
            <Modal.Header className="bg-warning">
                <Modal.Title id="contained-modal-title-vcenter" >
                    <i className="fa fa-warning me-2"></i>
                    توجه
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="pb-2 pt-3 text-center alert">
                   {message}
                </p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button variant="warning" onClick={onConfirm} style={{ width: '120px' }}>بله</Button>
                <Button variant="secondary" onClick={handleClose} style={{ width: '120px' }}>لغو عملیات</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmModal;
